import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';
import { browserHistory } from 'react-router';
import partial from 'lodash/partial';
import moment from 'moment';
import Money from 'common/components/money';
import author1 from 'assets/images/pap_testimonial-1-author.jpg';
import author2 from 'assets/images/pap_testimonial-2-author.jpg';
import author3 from 'assets/images/pap_testimonial-3-author.jpg';
import author4 from 'assets/images/pap_testimonial-4-author.jpg';
import oneToOneIcon from 'assets/images/icons/pap/PAP_cat_icon_1-to-1.svg';
import designConsultationIcon from 'assets/images/icons/pap/PAP_cat_icon_design-consultation.svg';
import { Meta } from 'common/components/meta';
import { getCanonicalURL } from 'common/utils';
import {
  trackClickWithMixpanel, trackMixpanel,
  MP_CLICKED_WORK_1_TO_1_EVENT_NAME, MP_CLICKED_DESIGN_CONSULTATION_EVENT_NAME
} from 'common/tracking';
import ModalDialog from 'common/components/modal/modal_dialog';

/* Testimonials per category ID */
const TESTIMONIALS_BY_ID = {
  7: {
    width: 'small-16 medium-16 large-8',
    avatar: author1,
    name: 'Matthew Stephenson, Executive Director',
    description: 'Code2College - Pflugerville, TX',
    text: 'We received nearly 100 entries from over 25 creatives and had so many high-quality submissions, I had to ask friends for help to choose a final logo.',
  },
  10: {
    width: 'small-16 medium-16 large-12',
    avatar: author2,
    name: 'Jeff Knowles',
    description: 'Florida Fundraising Association - Vero Beach, FL',
    text: "I’ve had great success with crowdspring, using the website to both redesign an existing website and to create a website from scratch. Both projects produced a large number of high quality design options.  Should I have a need for high quality design work in the future, crowdspring will be my first stop.",
  },
  8: {
    width: 'small-16 medium-16 large-8',
    avatar: author3,
    name: 'Bill Moore, CEO',
    description: 'Zello - Austin,TX',
    text: "Crowdspring's army of creatives generated thousands of ideas for naming our company. Now, Zello is the most popular walkie-talkie app with more than 100 million registered users."
  },
  3: {
    width: 'small-16 medium-16 large-8',
    avatar: author4,
    name: 'Elyse Dickerson, CEO',
    description: 'Eosera - Fort Worth,TX',
    text: "I love everything about crowdspring. The network of creatives is vast and provides great diversity in the results."
  }
}

/**
 * PAP0 categories list.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
export default class Categories extends Component {
  constructor(props) {
    super(props);

    this.state = { lastDraft: null, clickedCat: null, clickedSubcat: null };

    this.goToPAP = this.goToPAP.bind(this);
    this.handleSubcatClick = this.handleSubcatClick.bind(this);
    this.resumeDraft = this.resumeDraft.bind(this);
    this.closeDraftsModal = this.closeDraftsModal.bind(this);
  }

  componentDidMount() {
    const { fetchCategoriesIfNeeded, fetchDrafts, user } = this.props;

    fetchCategoriesIfNeeded();

    if (user.id) {
      fetchDrafts();
    }

    trackMixpanel("Started PAP0", {});
  }

  closeDraftsModal() {
    this.setState({ lastDraft: null, clickedCat: null, clickedSubcat: null });
  }

  handleSubcatClick(cat, subcat) {
    const { drafts } = this.props;
    /* same category/sub-category and created less than 15 days ago */
    const lastDraft = drafts.find(d => (
      d.sub_category === subcat.id && moment().diff(d.created_at, 'days') <= 15
    ));

    if (!lastDraft) {
      this.goToPAP(cat, subcat);
      return;
    }

    this.setState({ lastDraft, clickedCat: cat, clickedSubcat: subcat });
  }

  resumeDraft(draft) {
    this.closeDraftsModal();
    browserHistory.push(`/start-a-project/${draft.id}/review/`);
  }

  goToPAP(cat, subcat) {
    this.closeDraftsModal();

    trackClickWithMixpanel("Clicked subcategory", {
      pageName: "PAP0",
      subCategorySlug: subcat.slug,
      categorySlug: cat.slug,
    });

    browserHistory.push({
      pathname: `/start-a-project/${cat.slug}/${subcat.slug}/details/package/`,
      state: {origin: 'pap0'}
    });
  }

  goToDesignConsultation() {
    trackClickWithMixpanel(MP_CLICKED_DESIGN_CONSULTATION_EVENT_NAME, {
      pageName: "PAP0",
      pageArea: "Categories",
    });
    browserHistory.push('/help/contact/consultation/');
  }

  goToStart1to1() {
    trackClickWithMixpanel(MP_CLICKED_WORK_1_TO_1_EVENT_NAME, {
      pageName: "PAP0",
      pageArea: "Categories",
    });
    browserHistory.push({
      pathname: `/start-a-project/start-1-1/`,
      state: {origin: 'pap0'}
    });
  }

  renderConsultationTile() {
    return (
      <div className="columns medium-8 large-4" onClick={this.goToDesignConsultation}>
        <div className="tile subcategory">
          <i className="icon" dangerouslySetInnerHTML={{__html: designConsultationIcon}}/>
          <h4>Design Consultation</h4>
          <p>Can&apos;t decide?<br/>Let our experts help you.</p>
          <div className="pricing">
            <span className="min-price">free</span>
          </div>
          <div className="actions">
            <button className="btn btn-primary" onClick={this.goToDesignConsultation}>Request</button>
          </div>
        </div>
      </div>)
  }

  render1to1Tile() {
    return (
      <div className="columns medium-8 large-4" onClick={this.goToStart1to1}>
        <div className="tile subcategory">
          <i className="icon" dangerouslySetInnerHTML={{__html: oneToOneIcon}}/>
          <h4>Work 1-on-1</h4>
          <p>Find a creative and work with them directly.</p>
          <div className="pricing">
            <label>From</label>
            <Money className="min-price" value="200"/>
          </div>
          <div className="actions">
            <button className="btn btn-primary" onClick={this.goToStart1to1}>Start 1-to-1</button>
          </div>
        </div>
      </div>)
  }

  renderTestimonial(testimonial) {
    return (
      <div className={classNames('columns', testimonial.width || 'medium-8')}>
        <div className="testimonial">
          <div className="row">
            <div className="columns small-8 small-offset-4 medium-4 medium-offset-0 text-center">
              <img className="avatar avatar-lg avatar-round avatar-shadow" src={testimonial.avatar}/>
            </div>
            <div className="columns small-14 small-offset-1 medium-12 medium-offset-0">
              <div className="testimonial-text">
                <p>{testimonial.text}</p>
                <div className="attribution">
                  <div className="name">{testimonial.name}</div>
                  <div className="description">{testimonial.description}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>)
  }

  renderSubcat(cat, subcat, key) {
    const subcatIcon = require(`assets/images/icons/pap/PAP_cat_icon_${subcat.slug}.svg`);

    return (
      <div className="columns small-16 medium-8 large-4" key={key}
           onClick={partial(this.handleSubcatClick, cat, subcat)}>
        <div className="tile subcategory">
          <i className="icon" dangerouslySetInnerHTML={{__html: subcatIcon}}/>
          <h4>{subcat.name}</h4>
          <p className="description">{ subcat.description }</p>
          <div className="pricing">
            <label>From</label>
            <Money className="min-price" value={subcat['minimum_price']}/>
          </div>
          <div className="actions">
            <button className="btn btn-primary" onClick={partial(this.handleSubcatClick, cat, subcat)}>
              Start
            </button>
          </div>
        </div>
      </div>);
  }

  renderDraftsModal() {
    const { lastDraft, clickedCat, clickedSubcat } = this.state;

    if (!lastDraft) {
      return null;
    }

    let message = `You have a ${clickedSubcat.name} draft project`;
    if (lastDraft.title) {
      message += `  named "${lastDraft.title}".`;
    } else {
      message += " but did not give it a title.";
    }

    message += " Do you want to resume it or start a new draft project?";

    return (
      <ModalDialog modalOpen={true} closeAction={this.closeDraftsModal}
        modalHeader="Resume an earlier draft?" dialogClasses='drafts-modal'>
        <h3>You have an existing draft</h3>
        <p>{ message }</p>
        <div className="modal-actions">
          <button onClick={partial(this.resumeDraft, lastDraft)}
              className="btn btn-tertiary btn-block">
            Resume earlier draft
          </button>
          <button onClick={partial(this.goToPAP, clickedCat, clickedSubcat)}
              className="btn btn-secondary btn-block">
            Start new draft
          </button>
          <button onClick={this.closeDraftsModal} className="btn btn-text btn-block">
            Cancel
          </button>
        </div>
      </ModalDialog>
    );
  }

  render() {
    const { categories, popularOnly } = this.props;

    return (
      <div>
       <Meta
          title="Start a project"
          meta={[
            { name: "robots", content: popularOnly ? "noindex,follow":"index,follow" },
            { name: "description", content: "Post a logo design, web design, or writing job. Set your price and pick your favorite from an average of 110+ custom designs or written submissions." },
            { name: "keywords", content: "crowdsource, contests, design contests, writing contests, copywriting, design, crowdsourcing" }
          ]}
          link={[{ rel: "canonical", href: getCanonicalURL(popularOnly ? "/start-a-project/popular/":"/start-a-project/") }]}
        />
        {categories.map((cat, i) => {
          const showConsultationTile = [
            "clothing-merchandise", "product-packaging"
          ].includes(cat.slug);
          const show1to1Tile = [
            "logo-identity", "web-mobile-design", "business-advertising", "art-illustration"
          ].includes(cat.slug);

          return (
            <div key={i} className="category">
              <div className="row">
                <div className="columns small-16">
                  <h3>{cat.name}</h3>
                </div>
              </div>

              <div className="row">
                {cat['sub_categories'].map((subcat, j) => this.renderSubcat(cat, subcat, j))}

                { showConsultationTile && this.renderConsultationTile() }

                { show1to1Tile && this.render1to1Tile() }

                { TESTIMONIALS_BY_ID[cat.id] && this.renderTestimonial(TESTIMONIALS_BY_ID[cat.id]) }
              </div>
            </div>
          );
        })}

        { this.renderDraftsModal() }
      </div>
    )
  }
}

Categories.propTypes = {
  fetchCategoriesIfNeeded: PropTypes.func.isRequired,
  fetchDrafts: PropTypes.func.isRequired,
  categories: PropTypes.array,
  drafts: PropTypes.array.isRequired,
  user: PropTypes.object.isRequired,
}



// WEBPACK FOOTER //
// ./pap0/components/categories.jsx